import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const EnvVariables = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>
            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>Environment Variables</strong>
                <br />
                <br />
                <p>
                    Environment variables (Env Variables) are user-defined key-value pairs scoped at the
                    <strong> workspace level</strong>. This means they are accessible across <strong>all collections and requests</strong> within a single workspace.
                </p>
                <p>
                    They are particularly useful for managing different values based on environments like
                    <strong> development, staging, or production</strong>. For example, your API base URL or authorization token might vary across environments — environment variables make it easy to switch between them without editing each request manually.
                </p>
                <p>
                    You can refer to these variables using the double curly braces syntax: <code>{`{{baseUrl}}`}</code>. This allows you to write reusable and dynamic requests.
                </p>
                <p>
                    <strong>Example use case:</strong> If your development API base URL is
                    <code> https://dev.api.example.com</code>, and production is
                    <code> https://api.example.com</code>, you can define <code>baseUrl</code> for each environment separately. Your request can just use <code>{`{{baseUrl}}`}/users</code> and it will dynamically resolve depending on the selected environment.
                </p>
                <p>
                    Environment variables are stored under the <code>workspace</code> folder inside a <code>variables</code> directory. Each environment has its own file for easy Git tracking, version control, and offline access.
                </p>
                <p>
                    HawkClient allows you to switch environments easily from the workspace UI. Only one environment can be active at a time — and the active environment's variables will automatically be injected into all requests.
                </p>
            </Typography>
            <img
                src="/docs/envVariables.png"
                alt="validations"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    // maxWidth: '800px',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                }}
            />

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <p>
                    <strong>Variable Precedence</strong> helps determine which value is used when duplicate variable keys exist across scopes. In HawkClient, the order of precedence is:
                </p>
                <ol style={{ paddingLeft: '20px' }}>
                    <li><strong>Request Variables</strong> – highest priority</li>
                    <li><strong>Environment Variables</strong></li>
                    <li><strong>Collection Variables</strong></li>
                    <li><strong>Global Variables</strong> – lowest priority</li>
                </ol>
                <p>
                    This means if <code>baseUrl</code> is defined both in the collection and the active environment, the value from the environment will be used. However, if a request explicitly defines <code>baseUrl</code>, it will override everything else.
                </p>
                <p>
                    To manage environments more efficiently, HawkClient provides a clean UI for creating, editing, duplicating, and switching environments — no login or cloud sync is required.
                </p>
            </Typography>
        </Box>
    )
};

export default EnvVariables;